import { createUri } from '@/utils/util';

export const endpoint = createUri;

export const API_BASE_URL = import.meta.env.VITE_APIURL;
export const AUTH_BASE_URL = import.meta.env.VITE_AUTHURL;
export const APP_BASE_URL = import.meta.env.VITE_APPURL;

export const FEATURE_CONFIG_ENDPOINT = 'features.config.json';

export const TENANT_API_ENDPOINTS = Object.freeze({
	TENANT: 'tenant/get/:id',
});

export const AUTH_API_ENDPOINTS = Object.freeze({
	ACCEPT_COMPANY_INVITE: 'company/invite/accept',
});

export const BOOKING_API_ENDPOINTS = Object.freeze({
	ANY: 'bookings/:accountId/:startDate/:endDate',
	COMPANY: 'bookings/practice/:accountId/:startDate/:endDate',
	PROFESSIONAL: 'bookings/professional/:accountId/:startDate/:endDate',
	READ: 'bookings',
	DELETE: 'bookings/:accountId',
	CREATE: 'bookings/:accountId',
	UPDATE: 'bookings/:accountId',
});

export const AVAILABILITY_API_ENDPOINTS = Object.freeze({
	SEARCH: 'calendar/professional/availability/search/:profession/:startDate/:endDate',
	SINGLE: 'calendar/professional/availability/single/:id/:date',
	BY_DATE: 'calendar/professional/availability/:startDate/:endDate',
	BY_PROFESSIONAL: 'calendar/professional/availability/get/:professionalId/:start_date/:end_date',
	BY_PROFESSIONAL_FOR_COMPANY: 'calendar/professional/availability/get/company/:companyId/:professionalId/:start_date/:end_date',
	CANCEL: 'calendar/professional/availability/cancel/:id/:date',
	CANCEL_BOOKING_REQUEST: 'calendar/professional/availability/cancel-booking-request/:id/:date',
	ACCEPT_BOOKING: 'calendar/professional/availability/accept-booking/:id/:date',
	REJECT_BOOKING: 'calendar/professional/availability/reject-booking/:id/:date',
	REQUEST_BOOKING: 'calendar/professional/availability/request-booking/:id/:date',
	DELETE: 'calendar/professional/availability/delete/:id/:date',
	CREATE: 'calendar/professional/availability',
	UPDATE: 'calendar/professional/availability',
});

export const OFFER_API_ENDPOINTS = Object.freeze({
	SEARCH: 'offers/company/search/:profession/:startDate/:endDate/:experience',
	BOOK: 'offers/company/book-offer/:id',
	CANCEL: 'offers/company/cancel-offer/:id',
	CANCEL_OFFER_REQUEST: 'offers/company/cancel-offer-request/:id',
	CONFIRM: 'offers/company/confirm-offer/:id',
	REJECT: 'offers/company/reject-offer/:id',
	PRIVATE_ACCEPT: 'offers/company/private/accept-offer/:id',
	PRIVATE_CANCEL: 'offers/company/private/cancel-offer/:id',
	PRIVATE_REJECT: 'offers/company/private/reject-offer/:id',
	PRIVATE_UPDATE: 'offers/company/private/:id',
	PRIVATE_CREATE: 'offers/company/private',
	CREATE: 'offers/company',
	UPDATE: 'offers/company',
	UPDATE_DETAIL: 'offers/company/:id/update',
	UPDATE_APPLICATION: 'offers/company/update-application-to-offer/:id',
	DELETE: 'offers/company/:id',
	READ: 'offers/company/:id',
	READ_BY_COMPANY: 'offers/company/:id/:startDate/:endDate',
});

export const COMPANY_API_ENDPOINTS = Object.freeze({
	COMPANY: 'companies/:id',
	INVITE: 'companies/:id/invite',
	CANCEL_INVITE: 'companies/:companyId/invite/:inviteId/cancel',
	ACCEPT_INVITE: 'companies/invite/accept',
	PENDING_INVITES: 'companies/:id/invite/pending',
	COMPANIES: 'companies',
	COMPANY_REDEEM_CREDIT: 'companies/:id/wallet/redeem/request',
	TAWK_HASH_REQUEST: 'companies/:id/tawk/hash',
	REQUEST_PERMANENT_PLACEMENT: 'companies/:id/permanentplacement/request',
});

export const PROFESSIONAL_API_ENDPOINTS = Object.freeze({
	TAWK_HASH_REQUEST: 'professionals/tawk/hash',
});

export const INVITE_API_ENDPOINTS = Object.freeze({
	INVITE: 'invite/',
});

export const MESSAGE_API_ENDPOINTS = Object.freeze({
	GET_CONVERSATION: 'messages/:receivedByID/:sentByID',
	CREATE_MESSAGE: 'messages/',
	GET_CONVERSATION_UNREAD_COUNT: 'messages/getConversationUnreadCount/:receivedByID/:sentByID',
	GET_TOTAL_UNREAD_COUNT: 'messages/getTotalUnreadCount/:receivedByID',
	GET_UNREAD_CHATS: 'messages/getUnreadChats/:receivedByID',
});
